import {useCartItem} from "./useCartItem";
import useActivitySlice from "../../useActivity/useActivitySlice";

export const useActiveCartItem = () => {
  const {activeCartItemId} = useActivitySlice();
  return useCartItem(activeCartItemId);
};
